// extracted by mini-css-extract-plugin
export default {"playbookHeader":"styles_playbookHeader__aqyM3","playbookTitle":"styles_playbookTitle__9N8Oe","playbookTitleText":"styles_playbookTitleText__rKEkl"};